export enum RfpTypes {
  REQUEST_FOR_PRICING = 'RFP',
  MEMBER_RECRUITING = 'MR',
  SELLER_INITIATED_OFFER = 'SIO',
}
